import React, { FC, useCallback, MouseEventHandler, useRef, useEffect } from 'react';

import { GridColumn, Button, Label, cn, Desktop, Mobile, scrollToTop } from 'Modules/ui2';
import { useTranslation } from 'Modules/core/i18n';

import Check from '../check.sprite.svg';
import { PriceCardProps, PricesProps } from './types';
import styles from './index.module.scss';


export const PriceCard: FC<PriceCardProps> = ({
    className,
    onSelect,
    priceKey,
    selected,
    selectedClassName,
    priceTextSize = '40',
    mobile,
}) => {
    const timer = useRef<ReturnType<typeof setTimeout>>();
    const buttonRef = useRef<HTMLButtonElement>();
    const select = useCallback<MouseEventHandler<HTMLButtonElement>>(
        () => {
            onSelect(priceKey);
            if (mobile) {
                timer.current = setTimeout(() => {
                    const { top } = buttonRef.current?.getBoundingClientRect();
                    const { scrollTop } = document.documentElement || document.body;
                    scrollToTop(top + scrollTop - 4);
                }, 300);
            }
        },
        [priceKey, onSelect, mobile],
    );

    useEffect(
        () => () => clearTimeout(timer.current),
        [],
    );

    const { t } = useTranslation('registrationForm');
    return (
        <Button
            ref={buttonRef}
            variant='auxiliary'
            className={cn(
                styles.item,
                selected && styles.selected,
                selected && selectedClassName,
                className,
            )}
            onClick={select}
        >
            <Label weight='medium' textSize='18' component='div'>
                {t(`rate.tariffs.${priceKey}.description`)}
            </Label>
            <Desktop>
                <Check />
            </Desktop>
            <Mobile>
                <div className={styles.arrow} />
            </Mobile>
            <Label weight='demibold' textSize={priceTextSize} component='div'>
                {t(`rate.tariffs.${priceKey}.price`)}
            </Label>
        </Button>
    );
};

export const Prices: FC<PricesProps> = ({ data, selected, onSelect }) => (
    <GridColumn size={6} className={styles.container}>
        {data.map(price => (
            <PriceCard
                key={price.priceKey}
                selected={selected === price.priceKey}
                onSelect={onSelect}
                {...price}
            />
        ))}
    </GridColumn>
);

export * from './types';
